import { EditRuleBinding } from "./EditRuleBinding";
import { EditRuleCondition } from "./EditRuleCondition";

export class EditRulePattern {
  conditions: EditRuleCondition[];
  bindings: EditRuleBinding[];
}
